import { css } from "emotion";
import { InterpolationWithTheme } from "@emotion/core";


export const shareProfileSytyles: { [key: string]: InterpolationWithTheme<any> } = {
    shareButton: {
        background: "none",
        border: "none",
        color: "#ff316d",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: " 16px",
        fontWeight: 500,
        margin: "0px 20px"
    },
    shareIcon: {
        marginRight: "5px"
    }
}